/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVideoSlash: {
  name: 'video-slash';
  data: string;
} = {
  name: 'video-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.707 3.293a1 1 0 0 0-1.414 1.414l16 16a1 1 0 0 0 1.414-1.414l-16-16ZM9 6a1 1 0 0 1 1-1h6a2 2 0 0 1 2 2v2.15l.438-.549C19.62 7.125 22 7.961 22 9.851v4.298c0 1.89-2.38 2.726-3.562 1.25l-1.72-2.15a2.003 2.003 0 0 1-.25-.402A1 1 0 0 1 16 12V7h-6a1 1 0 0 1-1-1ZM3 7a1 1 0 0 1 1 1v9h10a1 1 0 1 1 0 2H4a2 2 0 0 1-2-2V8a1 1 0 0 1 1-1Zm17 2.85L18.28 12 20 14.15v-4.3Z" fill="currentColor"/></svg>`,
};
